import React from 'react';
import {connect} from 'react-redux';
import { CardSmall } from '../../../widgets/Cards';
import { fetchProblems, fetchProblem, editProblem, newProblem, deleteProblem } from '../../../../actions';
import List from '../List';

class Problem extends React.Component {

    //Initial Rendering
    componentDidMount() {   
        this.props.fetchProblems(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
            this.props.fetchProblems(this.props.patient._id);
        }   
    }

    //Render problem list
    renderContent () {
        return (
            this.props.problems.map(item => {
            return (
                <div className='btList' >{item.problem}</div>
             
            )
        })
    )};

    buttons() {
        var permit = this.props.selectedPermission.permission[0].chronicdisease;
        if (permit === "View only") {
            return null
        } else { 
            return <div><List /></div> 
        }  
    }

    render() {
      
        return (
            <CardSmall title='Problem List' buttons={this.buttons()}>
                    {this.renderContent()}
            </CardSmall>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        problems : Object.values(state.problems),
        userId : state.auth.userId,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {
    fetchProblems, fetchProblem, editProblem, newProblem, deleteProblem
    })(Problem);